import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  .no-result {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  h2 {
    font-size: 0.875rem;
    font-weight: 700;
    display: flex;
    gap: 20px;
    .year {
      flex: 1;
      text-align: right;
    }
    .line {
      border: 0.5px solid #333333;
    }
    .option {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-weight: 400;
    }
  }
`;
